export const AMAZON_MIN_DAILY_VOLUME = 100;
export const UNIUNI_MIN_DAILY_VOLUME = 100;
